/**
 * Care Plan Configuration Feature
 */
export enum CarePlanConfigurationFeature {
  /**
   * The autonomy assessment of a target senior user.
   */
  AutonomyAssessment = 'autonomy-assessment',

  /**
   * The notes of an activity group or type.
   */
  Notes = 'notes',

  /**
   * Current activation state of the activity group or type.
   */
  ActivationState = 'activation-state',

  /**
   * Time of the day when the care plan activity type starts.
   */
  StartsAtTime = 'starts-at-time',

  /**
   * Date when the care plan activity type starts.
   */
  StartsAtDate = 'starts-at-date',

  /**
   * Time of the day when the care plan activity type ends.
   */
  EndsAtTime = 'ends-at-time',

  /**
   * Schedule of the care plan activities group or activity type.
   */
  Schedule = 'schedule',

  /**
   * The name of the activity/task.
   */
  Name = 'name',

  /**
   * Medicine.
   */
  Medicine = 'medicine',

  /**
   * Medicine dosage.
   */
  MedicineDosage = 'medicine-dosage',

  /**
   * Medicine dosage unit.
   */
  MedicineDosageUnit = 'medicine-dosage-unit',

  /**
   * Medicine administration route.
   */
  MedicineAdministrationRoute = 'medicine-administration-route',

  /**
   * Medicine box.
   */
  MedicineBox = 'medicine-box',

  /**
   * Medicine SOS.
   */
  MedicineSOS = 'medicine-sos',

  /**
   * Entity shifts.
   */
  EntityShifts = 'entity-shifts',

  /**
   * User contacts.
   */
  UserContacts = 'user-contacts',

  /**
   * Medical appointment format.
   */
  MedicalAppointmentFormat = 'medical-appointment-format',

  /**
   * Medical appointment specialty.
   */
  MedicalAppointmentSpecialty = 'medical-appointment-specialty',

  /**
   * Medicine time of taking.
   */
  MedicineTimeOfTaking = 'medicine-time-of-taking',

  /**
   * Positioning seniors.
   */
  PositioningUprisings = 'positioning-uprisings',

  PositioningDecubitus = 'positioning-decubitus',

  /**
   * Tranportation.
   */
  TransportationCollectionBy = 'transportation-collection-by',
  TransportationDeliveryBy = 'transportation-delivery-by',
  TransportationCollectionAddress = 'transportation-collection-address',
  TransportationDeliveryAddress = 'transportation-delivery-address',

  /**
   * Elimination - going to the toilet.
   */
  EliminationGoingToiletPlace = 'going-to-the-toilet-place',
  EliminationGoingToiletConsumables = 'going-to-the-toilet-consumables',

  /**
   * Sociocultural
   */
  SocioculturalTransportationRequired = 'sociocultural-activity-transportation-required',
  SocioculturalPlace = 'sociocultural-activity-place',

  /**
   * Social interaction
   */
  SocialInteractionPlace = 'social-interaction-activity-place',
  SocialInteractionMeansOf = 'social-interaction-activity-means-of',
}
